import { EntityNotes } from "@modernary/mui/components/note";
import EntityAudits from "@/components/EntityAudits.vue";
import { RouterView, type RouterOptions } from "vue-router";
import { EntityDocuments } from "@modernary/mui/components/document";

const names = {
  tanks: "Tank.Tanks",
  list: "Tank.TankList",
  base: "Tank.TankBase",
  view: "Tank.TankView,",
  new: "Tank.TankNew",
  edit: "Tank.TankEdit",
  notes: "Tank.TankNotes",
  noteEdit: "Tank.TankNoteEdit",
  noteNew: "Tank.TankNoteNew",
  documents: "Tank.TankDocuments",
  documentEdit: "Tank.TankDocumentEdit",
  documentNew: "Tank.TankDocumentNew",
  audit: "Tank.TankAudit",
};

export { names as tankRouteNames };

const tankRoutes: RouterOptions["routes"] = [
  {
    path: "/tanks",
    name: names.tanks,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Tanks", lookupGroups: ["TankSubstance", "TankStatus"] },
        component: () => import("@/views/tank/TankList.vue"),
      },
      {
        path: "new/:facilityId(\\d+)?",
        component: () => import("@/views/tank/TankBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Tank New", isNew: true },
            component: () => import("@/views/tank/TankEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/tank/TankBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Tank View" },
            component: () => import("@/views/tank/TankView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Tank Edit", isForm: true },
            component: () => import("@/views/tank/TankEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Tank Notes" },
            component: {
              render: () => <EntityNotes idField="tankId" routeNamePrefix="Tank.TankNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Tank Note Edit", isForm: true },
            component: () => import("@/views/tank/TankNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Tank Note New", isForm: true },
            component: () => import("@/views/tank/TankNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Tank Documents" },
            component: {
              render: () => <EntityDocuments idField="tankId" routeNamePrefix="Tank.TankDocument" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Tank Document Edit", isForm: true },
            component: () => import("@/views/tank/TankDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Tank Document New", isForm: true },
            component: () => import("@/views/tank/TankDocuments.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Tank Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Tank" />,
            },
          },
        ],
      },
    ],
  },
];
export default tankRoutes;
